import { Stack, styled } from '@mui/material';

export const SectionWrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.grey[300],
  overflow: 'hidden',
}));
